import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=7a7eae55&scoped=true&lang=pug"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "./setting.vue?vue&type=style&index=0&id=7a7eae55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7eae55",
  null
  
)

export default component.exports